import Typography from "@material-ui/core/esm/Typography";
import clsx from 'clsx';
import React from 'react';
import useStyles from './TextStyles';
export default function Title({
  children,
  align,
  className,
  component = 'h3',
  hasNoSpacing,
  isBold
}) {
  const {
    title,
    noSpacing,
    bold
  } = useStyles();
  return /*#__PURE__*/React.createElement(Typography, {
    className: clsx({
      [noSpacing]: hasNoSpacing,
      [title]: !hasNoSpacing,
      [bold]: isBold
    }, className),
    "aria-label": "title",
    align: align,
    variant: "h3",
    component: component
  }, children);
}
Title.defaultProps = {
  align: 'left',
  hasSpacing: true,
  component: 'h3',
  hasNoSpacing: false,
  isBold: false
};